import Immutable from 'immutable';
import {
  RawStudioProjectFile,
  StudioProjectFile,
} from 'records/StudioProjectFile';

export type StudioId = string;

export interface RawStudioProjectFolder {
  id: number;
  name: string;
  path: string;
  parentfolderid: number;
  created: string;
  permission: string;
  folders: RawStudioProjectFolder[];
  files: RawStudioProjectFile[];
  studioprojectid: string;
}

export interface StudioProjectFolderData {
  id: number;
  name: string;
  path: string;
  parentfolderid: number;
  created: string;
  permission: string;
  folders: Immutable.List<StudioProjectFolderData>;
  files: Immutable.List<StudioProjectFile>;
  studioprojectid: string;
}

const defaultFolderValues: StudioProjectFolderData = {
  id: 0,
  name: '',
  path: '',
  parentfolderid: 0,
  created: '',
  permission: '',
  folders: Immutable.List<StudioProjectFolderData>(),
  files: Immutable.List<StudioProjectFile>(),
  studioprojectid: '',
};

export const StudioProjectFolderFactory = Immutable.Record(
  defaultFolderValues,
  'StudioProjectFolder'
);

export class StudioProjectFolder extends StudioProjectFolderFactory {
  static deserialize(
    rawStudioFolder: RawStudioProjectFolder
  ): StudioProjectFolder {
    return new StudioProjectFolder({
      ...rawStudioFolder,
      folders: Immutable.List(
        rawStudioFolder.folders?.map(StudioProjectFolder.deserialize)
      ),
      files: Immutable.List(
        rawStudioFolder.files?.map(StudioProjectFile.deserialize)
      ),
    });
  }
}

export type StudioProjectFolderList = Immutable.List<StudioProjectFolder>;

export type StudioProjectFolderMap = Immutable.OrderedMap<
  StudioId,
  StudioProjectFolder
>;
